// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"92cda2ab","684":"906ef6d2","784":"24ee10b4","787":"897376ee"}[chunkId] + ".chunk.js";
};